import { z } from 'zod';
import type {
  IncomingTransferCandidate,
  ListIncomingTransferCandidatesRequest,
  ListIncomingTransferCandidatesResponse,
} from './list-incoming-transfer-candidates.dto.js';
import { CounterpartySnapshotSchema } from '../counterparties/counterparties.schema.js';
import { IsoDateSchema, IsoDateTimeSchema } from '../shipments/shipments-types.js';

const trimmedStringSchema = z.string().trim().min(1);

export const IncomingTransferCandidateSchema: z.ZodType<IncomingTransferCandidate> = z
  .object({
    sourceShipmentCompanyId: z.uuid(),
    sourceShipmentId: z.uuid(),
    materialId: z.uuid(),
    createdAt: IsoDateTimeSchema,
    departedAt: IsoDateTimeSchema.nullable(),
    reportFrom: IsoDateSchema.nullable(),
    reportThrough: IsoDateSchema.nullable(),
    shipper: CounterpartySnapshotSchema,
    receiver: CounterpartySnapshotSchema,
    shippedRedemptionWeightLb: z.number().min(0).nullable(),
    shippedRefundValueCents: z.int().min(0).nullable(),
    totalWeightLb: z.number().min(0).nullable(),
    transferReference: trimmedStringSchema.nullable(),
  })
  .strict();

export const ListIncomingTransferCandidatesRequestSchema: z.ZodType<ListIncomingTransferCandidatesRequest> =
  z
    .object({
      companyId: z.uuid(),
      stationId: z.uuid(),
      materialId: z.uuid().optional(),
    })
    .strict();

export const ListIncomingTransferCandidatesResponseSchema: z.ZodType<ListIncomingTransferCandidatesResponse> =
  z
    .object({
      items: z.array(IncomingTransferCandidateSchema),
    })
    .strict();
